<template>
  <div class="regain-view-dialog">
    <el-dialog
      :visible.sync="dialogVisible"
      title="Regain View"
      :close-on-click-modal="false"
    >
      <div v-show="regainFilePath" class="upload-img-view">
        <p>picture of voucher:</p>
        <img v-show="isImage" :src="regainFilePath" />
        <a v-show="isPdf" :href="regainFilePath" target="_blank">
          {{ regainFilePath }}
        </a>
      </div>
      <span slot="footer">
        <el-button @click="dialogVisible = false">
          Cancel
        </el-button>
        <el-button type="primary" @click="handleEdit">
          Edit
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "RegainViewDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {}
    },
    // "booking"
    // "unit"
    level: {
      type: String,
      default: ""
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(bool) {
        this.$emit("update:visible", bool);
      }
    },
    regainFilePath() {
      // TODO: regain 后才显示的判断
      let origin = `${window.location.protocol}//${window.location.host}`;
      if (this.level === "booking") {
        let url = this.data && this.data.order_base_info && this.data.order_base_info.regain_file_path;
        return url ? `${origin}${url}` : url;
      } else if (this.level === "unit") {
        let url = this.data && this.data.regain_file_path;
        return url ? `${origin}${url}` : url;
      }
      return null;
    },
    isPdf() {
      if (!this.regainFilePath) {
        return false;
      }

      let res = this.regainFilePath.split(".");
      let ext = res[res.length - 1];
      return ext === "pdf";
    },
    isImage() {
      if (!this.regainFilePath) {
        return false;
      }

      let res = this.regainFilePath.split(".");
      let ext = res[res.length - 1];
      return ext === "jpg" || ext === "jpeg" || ext === "png";
    }
  },
  methods: {
    handleEdit() {
      this.dialogVisible = false;
      this.$emit("edit");
    }
  }
};
</script>

<style lang="scss" scoped>
.regain-view-dialog {
  .upload-img-view {
    width: 400px;
    height: 400px;

    img {
      width: 100%;
      height: auto;
    }
  }
}
</style>
